export const ORDER_TYPE_HUD_1 = 'HUD 1';

export const ACCOUNTING_PURCHASE_PRICE = 'purchase_price';
export const ACCOUNTING_COMMISSION_LISTING = 'commission_listing';
export const ACCOUNTING_COMMISSION_SELLING = 'commission_selling';
export const ACCOUNTING_OWNERS_BASIC_PREMIUM = 'owners_basic_premium';
export const ACCOUNTING_OWNERS_DISCLOSED = 'owners_disclosed';
export const ACCOUNTING_OWNERS_ACTUAL = 'owners_actual';
export const ACCOUNTING_OWNERS_FEE = 'owners_tx_guaranty_fee';
export const ACCOUNTING_LENDERS_BASIC_PREMIUM = 'lenders_basic_premium';
export const ACCOUNTING_LENDERS_DISCLOSED = 'lenders_disclosed';
export const ACCOUNTING_LENDERS_ACTUAL = 'lenders_actual';
export const ACCOUNTING_LENDERS_FEE = 'lenders_tx_guaranty_fee';

export const LISTING_ALLOWED_CD_AS = 'allowed_cd_as';
export const LISTING_ALLOWED_DISCLOSED_AS = 'allowed_disclosed_as';
export const LISTING_ENDORSEMENTS = 'allowed_policy_endorsements';
export const LISTING_LEDGER_ASSOCIATIONS = 'allowed_ledger_associations';
export const LISTING_OWNER_POLICY_TYPES = 'allowed_owner_policy_types';
export const LISTING_OWNER_POLICY_RATE_TYPES = 'allowed_owner_policy_rate_types';
export const LISTING_OWNER_POLICY_STATS = 'allowed_owner_policy_stats';
export const LISTING_LENDER_POLICY_TYPES = 'allowed_lender_policy_types';
export const LISTING_LENDER_POLICY_RATE_TYPES = 'allowed_lender_policy_rate_types';
export const LISTING_LENDER_POLICY_STATS = 'allowed_lender_policy_stats';
